import ModelUtil from '@leverege/model-util'
import Evaluator from '../Evaluator.js'
import AsyncEvaluator from '../AsyncEvaluator.js'

const TYPE = 'condition.Objectizer'
const EMPTY = {}

function create( options ) {
  const { matches, objectType, defaultValue, rules } = options || EMPTY
  return {
    type : TYPE,
    objectType,
    matches,
    defaultValue,
    rules : rules || []
  }
}

async function getValueAsync( model, cxt, options ) {
  const { evaluator, isAsync = false } = options || EMPTY
  const ev = evaluator || ( isAsync === true ? AsyncEvaluator : Evaluator )

  for ( let n = 0; n < model.rules.length; n++ ) {
    const rule = model.rules[n]
    if ( rule?.condition ) {

      // eslint-disable-next-line no-await-in-loop
      const v = await ev.satisfies( rule.condition, cxt )
      if ( v === true ) {
        return rule.value
      }
    }
  }
  return model.defaultValue
}

/**
 * Evaluates the ObjectizerModel against the context and returns
 * the appropriate value.
 * @param {ObjectizerModel} model The model containing the rules
 * @param {Object} cxt the context to evaluate
 * @param {Object} options options such as isAsync and evaluator
 * @returns Value or Promise<Value> if isAsync is true, a 
 * promise resolving to a value will returned. Otherwise, a 
 * value is returned
 */
function getValue( model, cxt, options ) {
  const { evaluator, isAsync = false } = options || EMPTY
  if ( isAsync ) {
    return getValueAsync( model, cxt, options )
  }

  const ev = evaluator || ( isAsync === true ? AsyncEvaluator : Evaluator )
  for ( let n = 0; n < model.rules.length; n++ ) {
    const rule = model.rules[n]
    if ( rule?.condition && ev.satisfies( rule.condition, cxt ) ) {
      return rule.value
    }
  }
  return model.defaultValue
}

export default { 
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'objectType' ),
  ...ModelUtil.createAllValue( 'defaultValue' ),
  ...ModelUtil.createAllValue( 'matches' ),
  ...ModelUtil.createAllArray( 'rules' ),

  getValue
}
